"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = __importDefault(require("vue"));
const Utils_1 = require("../../../utils/Utils");
exports.default = vue_1.default.extend({
    props: {
        guideData: {
            required: true,
        },
    },
    data() {
        return {
            arrowImageUrl: 'url(images/game/common/img_itemDetailModal.png)',
            borderImageUrl: 'url(images/game/common/img_dialog_frame.png)',
            currentPage: 1,
        };
    },
    computed: {
        showPrevArrow() {
            return this.currentPage !== 1;
        },
        showNextArrow() {
            return this.currentPage !== this.totalPage;
        },
        totalPage() {
            return this.guideData.pages.length;
        },
        nextButtonText() {
            if (this.currentPage === this.totalPage) {
                return 'OK';
            }
            return '次へ';
        },
        descriptions() {
            const currentPage = this.guideData.pages[this.currentPage - 1];
            const descriptions = currentPage[Object.keys(currentPage)[0]];
            return descriptions;
        },
        calculateFramePosition() {
            const posX = (this.currentPage - 1) * 556;
            const posY = (this.guideData.imageRow - 1) * 425;
            this.handleCondition();
            return `-${posX}px -${posY}px`;
        },
    },
    methods: {
        closeModal() {
            this.$emit('closeDialog');
        },
        /**
         * handle condition before showing twitter banner
         */
        handleCondition() {
            const twitterBanner = this.$refs.twitterBanner;
            if (twitterBanner) {
                twitterBanner.style.display = 'none';
                if ((this.guideData.title === 'はぐくまファームでの生活' &&
                    this.currentPage === 1) ||
                    (this.guideData.title === 'タネ植え' && this.currentPage === 3)) {
                    twitterBanner.style.display = 'block';
                }
            }
        },
        /**
         * Handler when click on next button
         */
        nextButtonHandler() {
            if (this.currentPage !== this.totalPage) {
                this.nextPage();
                return;
            }
            this.$emit('closeDialog');
        },
        /**
         * Go to next page
         */
        nextPage() {
            this.currentPage++;
        },
        /**
         * Go to previous page
         */
        prevPage() {
            this.currentPage--;
        },
        handleResponsive() {
            // Set scale of main image responsive
            const modalWidth = this.$refs.modal.clientWidth;
            this.$refs.mainImage.style.transform = `scale(${modalWidth * 0.00145})`;
            this.$refs.twitterBanner.style.transform = `scale(${modalWidth * 0.0015})`;
            // Make control arrow responsive
            this.$refs.nextArrow.style.transform = `translateY(-50%) scale(${modalWidth * 0.0015})`;
            this.$refs.prevArrow.style.transform = `translateY(-50%) scale(${modalWidth * 0.0015})`;
        },
        // open to twitter page
        openTwitter() {
            Utils_1.openTwitterPage();
        }
    },
    mounted() {
        this.handleResponsive();
        this.handleCondition();
        window.addEventListener('resize', this.handleResponsive);
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResponsive);
    },
});
